import { apiCall } from './api';
import { MSQ_CASE_STUDIES, MSQ_CASE_STUDY_DETAILS, MSQ_CASE_STUDY_STATUS, MSQ_CASE_STUDY_STATS } from '../config/api';

// Get all MSQ Case Studies
export const getMsqCaseStudies = async (params = {}) => {
  try {
    console.log('🚀 getMsqCaseStudies called with params:', params);
    console.log('🔗 Making API call to:', MSQ_CASE_STUDIES);
    
    const response = await apiCall(MSQ_CASE_STUDIES, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getMsqCaseStudies:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getMsqCaseStudies:', error);
    throw error;
  }
};

// Get MSQ Case Study by ID
// Expected API endpoint: GET /api/msq-case-studies/{id}
// Expected response structure:
// {
//   "success": true,
//   "data": {
//     "id": 1,
//     "title": "HTML formatted title",
//     "description": "HTML formatted description", 
//     "status": "active|inactive|pending",
//     "module_number": "MODULE-001",
//     "video_url": "HTML formatted video content or URL",
//     "created_at": "2024-01-01T00:00:00Z",
//     "updated_at": "2024-01-01T00:00:00Z",
//     "meta": {
//       "tags": ["tag1", "tag2"],
//       "category": "case_study",
//       "duration": "2 hours",
//       "difficulty": "intermediate"
//     }
//   }
// }
export const getMsqCaseStudyById = async (caseStudyId) => {
  try {
    const endpoint = MSQ_CASE_STUDY_DETAILS.replace('{id}', caseStudyId);
    console.log('🔍 Fetching case study details from:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    
    console.log('📡 API Response from getMsqCaseStudyById:', response);
    return response;
  } catch (error) {
    console.error('❌ Error fetching MSQ Case Study:', error);
    throw error;
  }
};

// Create new MSQ Case Study
export const createMsqCaseStudy = async (caseStudyData) => {
  try {
    console.log('🚀 createMsqCaseStudy called with data:', caseStudyData);
    console.log('🔗 Making API call to:', MSQ_CASE_STUDIES);
    
    const response = await apiCall(MSQ_CASE_STUDIES, {
      method: 'POST',
      data: caseStudyData
    });
    
    console.log('📡 API Response from createMsqCaseStudy:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating MSQ Case Study:', error);
    throw error;
  }
};

// Update MSQ Case Study
export const updateMsqCaseStudy = async (caseStudyId, caseStudyData) => {
  try {
    const endpoint = MSQ_CASE_STUDY_DETAILS.replace('{id}', caseStudyId);
    console.log('🚀 updateMsqCaseStudy called with ID:', caseStudyId, 'and data:', caseStudyData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: caseStudyData
    });
    
    console.log('📡 API Response from updateMsqCaseStudy:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating MSQ Case Study:', error);
    throw error;
  }
};

// Delete MSQ Case Study
export const deleteMsqCaseStudy = async (caseStudyId) => {
  try {
    const endpoint = MSQ_CASE_STUDY_DETAILS.replace('{id}', caseStudyId);
    const response = await apiCall(endpoint, {
      method: 'DELETE'
    });
    return response;
  } catch (error) {
    console.error('Error deleting MSQ Case Study:', error);
    throw error;
  }
};

// Update MSQ Case Study status
export const updateMsqCaseStudyStatus = async (caseStudyId, status) => {
  try {
    const endpoint = MSQ_CASE_STUDY_STATUS.replace('{id}', caseStudyId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating MSQ Case Study status:', error);
    throw error;
  }
};

// Get MSQ Case Study statistics
export const getMsqCaseStudyStats = async () => {
  try {
    const response = await apiCall(MSQ_CASE_STUDY_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching MSQ Case Study stats:', error);
    throw error;
  }
};
